import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {catchError, tap} from "rxjs/operators";
import {RestreamProject, RestreamItem, SrtStatusResponse} from "../interfaces";

@Injectable({providedIn: 'root'})
export class RestreamsService {

  constructor(private http: HttpClient){
  }

  fetch():Observable<RestreamProject[]>{
    return this.http.get<RestreamProject[]>('/api/restream')
  }

  getById(id:string):Observable<RestreamProject>{
    return this.http.get<RestreamProject>(`/api/restream/${id}`)
  }
 
  create(title?:string ): Observable<RestreamProject>{
    const formData = new FormData()
   
    formData.append('title',title || 'Нова ретрансляція')

    return this.http.post<RestreamProject>('/api/restream', formData)
  }
  
  createSrtPoint(title?: string): Observable<RestreamProject>{
    return this.http.post<RestreamProject>('/api/restream', {kind: 'srt', title: title || ''})
  }

  setSrtLatency(id: string, srtLatencyMs: number): Observable<RestreamProject>{
    return this.http.patch<RestreamProject>(`/api/restream/${id}`, {srtLatencyMs})
  }

  srtStatus(): Observable<SrtStatusResponse>{
    return this.http.get<SrtStatusResponse>('/api/restream/srt-status')
  }

  srtRotate(id: string, which: 'publish' | 'read'): Observable<{point: RestreamProject, kicked: number}>{
    return this.http.post<{point: RestreamProject, kicked: number}>(`/api/restream/${id}/srt-rotate`, {which})
  }

  delete(id:string):Observable<RestreamProject>{
    return this.http.delete<RestreamProject>(`/api/restream/${id}`)
  }
 
 

 
  update(id:string, restreams:RestreamItem[], title:string): Observable<RestreamProject>{
     
    return this.http.patch<RestreamProject>(`/api/restream/${id}`, {restreams, title})
  }

  

}
